import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../../../../app/hooks";
import FormGridRow from "../../../../../common/components/functional/formGridRow/FormGridRow";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { SalaryType } from "../../../../orders/types/salaryType";
import { WorkTimeBankSettings } from "../workTimeBank/WorkTimeBankSettings";
import { PeriodStarts } from "./PeriodStarts";
import { WorkHours } from "./WorkHours";

export const WorkTimeInfo = () => {
  const { t } = useTranslation(["talentProfile", "common"]);

  const workTimeTypes = useAppSelector((state) => state.localized.workTimeType);
  const employment = useAppSelector((state) => state.employment.additionalInfo);
  // Temporary: hide flex hour settings for hourly wage until flex time is tested for those employments (YLPE-8604)
  const flexiHoursSettingsAvailable =
    !employment.isShift &&
    employment.details?.salaryType === SalaryType.Monthly;

  const LabeledRow = ({
    label,
    value,
  }: {
    label: string;
    value: string | number | undefined;
  }) => (
    <FormGridRow label={label} labelSize={2} fieldSize={10}>
      <Typography>{value}</Typography>
    </FormGridRow>
  );

  return (
    <FormSection title={t("workTimeInfo")}>
      <LabeledRow
        label={t("talentProfile:workTimeType")}
        value={workTimeTypes[employment.details?.workTimeType]}
      />

      <WorkHours />

      {/* TODO: should be shown only when period start date is set.
       * condition removed temporary to allow fixing incorrect data from migration
       */}
      <PeriodStarts />

      <LabeledRow
        label={t("talentProfile:isAveragingPeriodInUse")}
        value={
          employment.details?.isAveragingPeriodInUse
            ? t("common:yes")
            : t("common:no")
        }
      />

      <LabeledRow
        label={t("talentProfile:agreeToOvertime")}
        value={
          employment.details?.talentAgreesExtraWork
            ? t("common:yes")
            : t("common:no")
        }
      />

      {/* Hide work time bank and flexi hours settings for shift type employments */}
      <Grid item container xs={2} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("talentProfile:workTimeBankSettings")}
        </Typography>
      </Grid>
      <Grid item container xs={10} display="flex" alignItems="center">
        {!employment.isShift ? (
          <WorkTimeBankSettings
            timeBankSettings={employment.details?.timeBankSettings}
            type="workTimeBank"
          />
        ) : (
          <Typography>{"-"}</Typography>
        )}
      </Grid>
      <Grid item container xs={2} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("talentProfile:flexiHoursSettings")}
        </Typography>
      </Grid>
      <Grid item container xs={10} display="flex" alignItems="center">
        {flexiHoursSettingsAvailable ? (
          <WorkTimeBankSettings
            timeBankSettings={employment.details?.flexibleHoursSettings}
            type="flexiHours"
          />
        ) : (
          <Typography>{"-"}</Typography>
        )}
      </Grid>
    </FormSection>
  );
};
